import './style.scss';
import Colorpicker from './colorpicker.js';

export default Colorpicker;